import "./NavBar.css";
import { 
  AppBar, 
  Box, 
  Toolbar, 
  IconButton, 
  Typography, 
  Menu, 
  Container, 
  Avatar, 
  Button, 
  Tooltip, 
  MenuItem 
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useState } from 'react';
import logo from "../../images/kaylee_logo.png";

const pages = [
  { name: 'Home', href: '#home' },
  // { name: 'About', href: '#about' },
  { name: 'Portfolio', href: '#portfolio' },
  { name: 'Experience', href: '#experience' },
  { name: 'Contact', href: '#contact' },
];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNavClick = (href) => {
    window.location.href = href;
    handleCloseNavMenu();
  };

  return (
    <AppBar 
      position="fixed" 
      sx={{ 
        background: 'linear-gradient(to right, rgba(33, 32, 32, 0.95), rgba(26, 26, 26, 0.95))',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(114, 239, 221, 0.1)',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Desktop Logo */}
          <Box
            component="img"
            src={logo}
            alt="Kaylee Burch Logo"
            sx={{
              display: { xs: 'none', md: 'flex' },
              mr: 1,
              maxWidth: 150,
              width: 'auto !important',
              height: 'auto',
              transition: 'transform 0.3s ease-in-out',
              '&:hover': {
                transform: 'scale(1.05)'
              }
            }}
          />

          {/* Mobile Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              sx={{ 
                color: '#72efdd',
                '&:hover': {
                  backgroundColor: 'rgba(114, 239, 221, 0.1)'
                }
              }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
                '& .MuiPaper-root': {
                  backgroundColor: 'rgba(33, 32, 32, 0.95)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(114, 239, 221, 0.1)',
                },
              }}
            >
              {pages.map((page) => (
                <MenuItem 
                  key={page.name} 
                  onClick={() => handleNavClick(page.href)}
                  sx={{
                    '&:hover': {
                      backgroundColor: 'rgba(114, 239, 221, 0.1)',
                    }
                  }}
                >
                  <Typography 
                    textAlign="center" 
                    sx={{ 
                      color: 'white',
                      fontSize: '1.1rem',
                      fontWeight: 'medium'
                    }}
                  >
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Mobile Logo */}
          <Box
            component="img"
            src={logo}
            alt="Kaylee Burch Logo"
            sx={{
              display: { xs: 'flex', md: 'none' },
              flexGrow: 0,
              maxWidth: 100,
              width: 'auto !important',
              height: 'auto',
              justifyContent: 'center'
            }}
          />

          {/* Desktop Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end' }}>
            {pages.map((page) => (
              <Button
                key={page.name}
                onClick={() => handleNavClick(page.href)}
                sx={{ 
                  my: 2, 
                  color: 'white', 
                  display: 'block',
                  mx: 1,
                  fontSize: '1.1rem',
                  fontWeight: 'medium',
                  transition: 'all 0.3s ease-in-out',
                  '&:hover': {
                    backgroundColor: 'rgba(114, 239, 221, 0.1)',
                    color: '#72efdd',
                    transform: 'translateY(-2px)'
                  },
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
